<div *ngIf="!pane || !pane.collections else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="content">
    <div class="content-cards">
      <div *ngFor="let collection of collections; let i = index; trackBy: trackContentByFn" class="card-wrap">
        <app-collection-card-mini [collection]="collection"
                                  [linkEnable]="false"
                                  (action)="onAction()"
                                  (openInModal)="onOpenCard($event)"
                                  (favoriteChanged)="onFavoriteChanged(i)">
        </app-collection-card-mini>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>

    <ng-container *ngIf="!collections.length && !pane.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-empty [empty]="emptyObj"></app-empty>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           (closed)="onCloseCard()">
  <app-modal-body>
    <article rel="main">
      <app-collection-card [collection]="item" [meta]="true" (isCloseAllModals)="onCloseCard()"></app-collection-card>
    </article>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal"
                  (closed)="onCloseCard()">
  <app-mobile-modal-title>{{ 'collections.collection' | customLocale }}</app-mobile-modal-title>

  <app-mobile-modal-body>
    <article rel="main">
      <app-collection-card [collection]="item" [meta]="true"></app-collection-card>
    </article>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
